import React, { useEffect } from 'react';
import {
    Create,
    SimpleForm,
    TextField,
    ReferenceInput,
    NumberInput,
    SelectInput,
    required,
    number,
    minValue,
    maxValue,
} from 'react-admin';
import { validatePrecision } from '../../coins/utils/precisionValidate';

const validateTxMax = [required(), number()];
const validateTxMin = [required(), number()];
const inputStyle = { width: '20em', display: 'block' };

let accountId = '';

const tradeFlagChoices = [
    { id: 3, name: 'BUY/SELL' },
    { id: 1, name: 'BUY' },
    { id: 2, name: 'SELL' },
];

function parseReferenceInputChange(data) {
    const res = [];
    Object.keys(data).forEach(key => {
        if (!isNaN(Number(key))) {
            res.push(data[key]);
        }
    });
    return res.join('');
}

const AccountCoinCreate = props => {
    const [selectSymbol, setSymbol] = React.useState('');
    const [selectCurrency, setCurrency] = React.useState('');
    const [currencyRate, setCurrencyRate] = React.useState(null);
    const [defaultFormValue, setDefaultFormValue] = React.useState({});

    // 从URL参数中获取accountId
    const getAccountIdFromUrl = () => {
        // 检查hash fragment中的参数
        const hash = window.location.hash;
        if (hash && hash.includes('?')) {
            const queryString = hash.split('?')[1];
            const urlParams = new URLSearchParams(queryString);
            return urlParams.get('accountId');
        }
        
        // 如果hash中没有参数，再检查search
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('accountId');
    };

    useEffect(() => {
        accountId = getAccountIdFromUrl();
        const dataObj = {
            txMin: 500,
            txMax: 20000,
            tradeFlag: 3, // 默认BUY/SELL
            accountId: accountId // 添加accountId
        };
        setDefaultFormValue(dataObj);
    }, []);

   

    const redirect = (basePath, id, data) => {
        return `/accountcoins/${accountId}/show`;
    };

    return (
        <Create title="Account Coin" {...props}>
            <SimpleForm redirect={redirect} defaultValue={defaultFormValue}>
                <ReferenceInput 
                    source="symbol" 
                    label="Symbol" 
                    reference="system/coins" 
                    onChange={val => {
                        const symbol = parseReferenceInputChange(val);
                        setSymbol(symbol);
                    }}
                >
                    <SelectInput optionText="symbol" optionValue="symbol" />
                </ReferenceInput>
                
                
                <SelectInput 
                    source="tradeFlag" 
                    label="Trade Flag" 
                    choices={tradeFlagChoices}
                    defaultValue={3}
                />
                
                <NumberInput
                    style={inputStyle}
                    source="txMax"
                    label="Tx Max"
                    validate={validateTxMax}
                />
                
                <NumberInput
                    style={inputStyle}
                    source="txMin"
                    label="Tx Min"
                    validate={validateTxMin}
                />

            </SimpleForm>
        </Create>
    );
};

export default AccountCoinCreate; 